import _extends from '/app/node_modules/babel-runtime/helpers/extends';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
export default {
    data: function data() {
        return {
            noAplica: 'No aplica'
        };
    },

    computed: _extends({}, mapState("affiliations/form", ['comission']), {
        comisionesMarca: function comisionesMarca() {
            var _this = this;

            return this.comission.comisionesMarca.filter(function (x) {
                if (x.comisionCredito == _this.noAplica && x.comisionDebito == _this.noAplica && x.comisionForaneaCredito == _this.noAplica && x.comisionForaneaDebito == _this.noAplica && x.flatCredito == _this.noAplica && x.flatDebito == _this.noAplica && x.flatForaneaCredito == _this.noAplica && x.flatForaneaDebito == _this.noAplica) {
                    return false;
                }
                return true;
            });
        }
    }),
    methods: {
        verifyNoAplica: function verifyNoAplica(param) {
            if (param == this.noAplica) {
                return '-';
            }
            return param;
        },
        validarColumnas: function validarColumnas(atributo) {
            var _this2 = this;

            var valor = false;
            this.comisionesMarca.forEach(function (element) {
                if (element[atributo] != _this2.noAplica) {
                    valor = true;
                }
            });
            return valor;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shared/table/comisions-table.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shared/table/comisions-table.vue
// module chunks = 34